<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>

    <Scroll id="container" :height="height">
      <Tabs>
        <TabPane label="最近下发" icon="md-arrow-down">
          <Form ref="formStep1" :label-width="120" :model="formItem">
            <FormItem label="操作类型：">
              <label>{{downData.isSet == null? "无数据" : downData.isSet == "是"? "标定" : "复核"}}</label>
            </FormItem>
            <FormItem label="下发日期：">
              <label>{{downData.commandTimestamp == null?"无数据":downData.commandTimestamp}}</label>
            </FormItem>
            <FormItem label="下发状态：">
              <label>{{downData.state == null?"无数据":downData.state == 0?"等待设备获取":downData.state == 1?"设备已获取，等待设备响应":"下发成功"}}</label>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="标定值" icon="ios-cog">
          <Form ref="formStep1" :label-width="120" :model="formItem">
            <FormItem label="标定时间：">
              <label>{{upData.startTimeInit == null ? "无数据" : upData.startTimeInit}}</label>
            </FormItem>
            <FormItem label="特征常数：">
              <label>{{upData.constantInit == null? "无数据": upData.constantInit}}</label>
            </FormItem>
            <FormItem label="管道压力(Pa)：">
              <label>{{upData.pressureInit == null? "无数据": upData.pressureInit}}</label>
            </FormItem>
            <FormItem label="流速(L/h)：">
              <label>{{upData.velocityInit == null? "无数据": upData.velocityInit}}</label>
            </FormItem>
            <FormItem label="温度(℃)：">
              <label>{{upData.temperatureInit == null? "无数据": upData.temperatureInit}}</label>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="复核值" icon="ios-cog-outline">
          <Form ref="formStep1" :label-width="120" :model="formItem">
            <FormItem label="采集时间：">
              <label>{{upData.startTimeCurrent == null? "无数据": upData.startTimeCurrent == "1970-01-01 08:00:00"?"无数据" : upData.startTimeCurrent}}</label>
            </FormItem>
            <FormItem label="特征常数：">
              <label>{{upData.constantCurrent == null? "无数据": upData.constantCurrent == 0?"无数据":upData.constantCurrent}}</label>
            </FormItem>
            <FormItem label="管道压力(Pa)：">
              <label>{{upData.pressureCurrent == null? "无数据": upData.pressureCurrent == 0?"无数据":upData.pressureCurrent}}</label>
            </FormItem>
            <FormItem label="流速(L/h)：">
              <label>{{upData.velocityCurrent == null? "无数据": upData.velocityCurrent == 0?"无数据":upData.velocityCurrent}}</label>
            </FormItem>
            <FormItem label="温度(℃)：">
              <label>{{upData.temperatureCurrent == null? "无数据": upData.temperatureCurrent == 0?"无数据":upData.temperatureCurrent}}</label>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="复核结果" icon="ios-cog-outline">
          <Form ref="formStep1" :label-width="120" :model="formItem">
            <FormItem label="标定特征常数：">
              <label>{{upData.constantInit == null? "无数据": upData.constantInit}}</label>
            </FormItem>
            <FormItem label="复核特征常数：">
              <label>{{upData.constantCurrent == null? "无数据": upData.constantCurrent == 0?"无数据":upData.constantCurrent}}</label>
            </FormItem>
            <FormItem label="复核计算值(%)：">
              <label>{{computed}}</label>
            </FormItem>
            <FormItem label="阈值(%)：">
              <label>{{defaultThreshold}}</label>
            </FormItem>
            <FormItem label="复核结果：">
              <label>{{computed > defaultThreshold ? "异常" : "正常"}}</label>
            </FormItem>
          </Form>
        </TabPane>
      </Tabs>
    </Scroll>
  </div>
</template>
<script>
export default {
  props: {
    isPc: ""
  },
  data() {
    return {
      formItem: {
        operatation: "0",
        operatationType: "0"
      },
      isSpinShow: false,
      height: document.body.clientHeight * 0.7,
      upData: {},
      downData: {},
      defaultThreshold: 8,
      computed: 0
    };
  },
  methods: {
    // 获取特征值阈值
    getThreshold(meterInfo) {
      this.isSpinShow = true;

      var that = this;
      var resultCode = 0;
      $.ajax({
        url: "/api/getLastDownParameter",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          deviceId: meterInfo.meterId
          //   deviceId: "19061300000002"
        }),
        dataType: "json",
        success: function(receiveData) {
          console.log(receiveData);

          resultCode = receiveData.errorCode;
          if (resultCode == 0) {
            console.log(receiveData);
            var columns = receiveData.body.down.columns;
            for (let i = 0; i < columns.length; i++) {
              if (columns[i].key == "ratioCoefThreshold") {
                this.defaultThreshold =
                  columns[i]["ratioCoefThreshold"].default == undefined
                    ? 8
                    : columns[i]["ratioCoefThreshold"].default;
              }
            }
          }

          that.isSpinShow = false;
        },
        error: function(textStatus) {
          resultCode = -1;
          that.isSpinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });

      return resultCode;
    },
    getLastCharacteristicCommand(meterInfo) {
      this.isSpinShow = true;
      var that = this;
      var resultCode = 0;
      $.ajax({
        url: "/api/getLastCharacteristicRecord",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          deviceId: meterInfo.meterId
          //   deviceId: "19061300000002"
        }),
        dataType: "json",
        success: function(receiveData) {
          // console.log(receiveData);

          resultCode = receiveData.errorCode;
          if (resultCode == 0) {
            that.upData = !receiveData.body.up
              ? {}
              : !receiveData.body.up.data
              ? {}
              : receiveData.body.up.data[0] || {};
            that.downData = !receiveData.body.down
              ? {}
              : !receiveData.body.down.data
              ? {}
              : receiveData.body.down.data[0] || {};
            that.computed =
              that.upData.constantInit == null
                ? "无数据"
                : that.upData.constantCurrent == 0
                ? "无数据"
                : ((that.upData.constantCurrent - that.upData.constantInit) /
                    that.upData.constantInit) *
                  100;
            if (!isNaN(that.computed)) {
              that.computed = that.computed.toFixed(2);
            }
          }

console.log(that.downData);
          that.isSpinShow = false;
        },
        error: function(textStatus) {
          resultCode = -1;
          that.isSpinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });

      return resultCode;
    }
  },
  mounted() {}
};
</script>